import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soitem",
  "use": "icon-soitem-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-soitem\"><path d=\"M768 128v260.64a112.064 112.064 0 0 1 0 214.72V672h128v224H576v-64H128V128h640z m64 608h-192v96h192v-96zM704 192H192v576h384v-96h128v-68.64a112.064 112.064 0 0 1 0-214.72V192z m-192 416v64H288v-64h224z m224-160a48 48 0 1 0 0 96 48 48 0 0 0 0-96z m-224 0v64H288v-64h224z m96-160v64H288V288h320z\" fill=\"#ffffff\" p-id=\"9061\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol